import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 12.6274C3 7.65688 7.02944 3.62744 12 3.62744C16.9706 3.62744 21 7.65688 21 12.6274C21 17.598 16.9706 21.6274 12 21.6274C7.02944 21.6274 3 17.598 3 12.6274ZM10.9998 16.8699V13.6273H7.75757V11.6273H10.9998L10.9998 8.38501H12.9998V11.6273H16.2425V13.6273H12.9998V16.8699H10.9998Z\" fill=\"#997236\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol